import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import * as actions from '@actions/recovery-bin';
import Message from '@rootCommon/services/message';
import RecoveryBinRecordService from '@rootCommon/services/recovery-bin-record-service';
import { BaseMessageDto, IdType } from '@rootTypes/common';
import { RecoveryBinPatientsRequest, RecoveryBinPatientsResponse } from '@rootTypes/recovery-bin';
import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchDeletedPatientsAsync(action: { payload: RecoveryBinPatientsRequest }) {
  try {
    const deletedPatients: RecoveryBinPatientsResponse = yield call(
      RecoveryBinRecordService.getDeletedPatientsAdmin, action.payload,
    );

    yield put(actions.fetchDeletedPatients.success(deletedPatients));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchDeletedPatients.failure(error));
  }
}

// delete
function* permanentlyDeletePatientsAsync(action: { payload: IdType[] }) {
  try {
    const res: BaseMessageDto = yield call(
      RecoveryBinRecordService.deletePatientsPermanentlyAdmin, { ids: action.payload },
    );
    yield put(actions.permanentlyDeletePatients.success(action.payload));
    Message.success(res.message);
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.permanentlyDeletePatients.failure(error));
  }
}

// recover
function* recoverDeletedPatientsAsync(action: { payload: IdType[] }) {
  try {
    const res: BaseMessageDto = yield call(RecoveryBinRecordService.recoverPatientsAdmin, { ids: action.payload });
    yield put(actions.recoverDeletedPatients.success(action.payload));
    Message.success(res.message);
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.recoverDeletedPatients.failure(error));
  }
}

function* watchFetchDeletedPatients() {
  yield takeLatest(actions.fetchDeletedPatients.request, fetchDeletedPatientsAsync);
}

function* watchPermanentlyDeletePatients() {
  yield takeLatest(actions.permanentlyDeletePatients.request, permanentlyDeletePatientsAsync);
}

function* watchRecoverDeletedPatients() {
  yield takeLatest(actions.recoverDeletedPatients.request, recoverDeletedPatientsAsync);
}

function* watchRecoveryBin(): SagaGenerator {
  yield all([
    watchFetchDeletedPatients(),
    watchPermanentlyDeletePatients(),
    watchRecoverDeletedPatients(),
  ]);
}

export default watchRecoveryBin;
